import { driver } from 'driver.js';
import '../main.css';
import 'driver.js/dist/driver.css';
export const auditLogsDriverObj = (dispatch) => {
  const driverObj = driver({
    showProgress: true,
    nextBtnText: 'Next',
    prevBtnText: 'Previous',
    doneBtnText: 'Done',
    popoverClass: 'driverjs-theme',
    steps: [
      {
        element: '.dateRange',
        popover: {
          title: 'Select Date Range',
          description:
            'Use this feature to filter audit logs by a specific date range. This helps you narrow down the logs to a relevant time period for analysis.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.auditLogsMainTable',
        popover: {
          title: 'Audit Logs Overview',
          description:
            'This table provides a detailed overview of all the audit logs. You can review, filter, and analyze user activities within the system.',
          side: 'left',
          align: 'start',
        },
      },
    ],
  });
  return driverObj;
};
export default auditLogsDriverObj;
